<template>
  <div id="app">
    <transition :name="transitionName">
      <keep-alive :include="keepAliveNames">
        <router-view />
      </keep-alive>
    </transition>
    <guide-page />
    <orientation-tip />
  </div>
</template>

<script>
import GuidePage from './components/GuidePage'
import OrientationTip from './components/OrientationTip'

export default {
  components: { GuidePage, OrientationTip },
  name: 'App',
  data () {
    return {
      keepAliveNames: ['layout'],
      transitionName: '',
      loading: false
    }
  },
  watch: {
    '$route' (to) {
      const stackType = to.params.stackType

      if (stackType === 'push' && to.matched.length) {
        // use matched[0].name to record keep alive stack form <keep-alive />
        this.keepAliveNames.push(to.matched[0].components.default.name)
        this.transitionName = 'slide-left'
      } else if (this.$root.$$backing) {
        this.keepAliveNames.length > 1 && this.keepAliveNames.pop()
        this.transitionName = 'slide-right'
      } else {
        if (stackType !== 'hold') { // replace sometimes need to hold stack history
          this.keepAliveNames.length > 1 && this.keepAliveNames.pop()
        }
        this.transitionName = ''
      }

      this.$root.$$backing = false
    },
    keepAliveNames (v) {
      this.$root.historyStack = v
    }
  }
}
</script>
<style lang="less">
  @import "./vars.less";

  html, body {
    height: 100vh;
    padding: 0;
    margin: 0;
    overflow: hidden;
    background-color: @background-color;
  }
  #app {
    height: 100vh;
    overflow: hidden;
    position: relative;
    z-index: 0;
  }
  div, p, h1, h2, h3, h4, h5, h6 {
    box-sizing: border-box;
  }

  .slide-left-enter-active,
  .slide-right-enter-active {
    transition: transform, .4s ease;
    position: absolute;
    z-index: 1
  }
  .slide-left-leave-active,
  .slide-right-leave-active {
    transition: transform, 1s ease;
    position: absolute;
    z-index: -1;
    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.03);
    }
  }

  .slide-left-enter {
    transform: translateX(100%);
  }
  .slide-left-leave-to {
    transform: translateX(-100%);
  }

  .slide-right-enter {
    transform: translateX(-100%);
  }
  .slide-right-leave-to {
    transform: translateX(100%);
  }
</style>
